@solidale.controller 'LocRequestCtrl', ['$rootScope', '$scope', '$state', '$timeout','Locrequest', '$q', ($rootScope, $scope, $state, $timeout, Locrequest, $q) ->

	$scope.status = 1
	$scope.isRefresh = false
	$scope.request = 
		p1: []
		p2: []
		p3: []
		p4: []

	
	# ==========================
	# Request Render
	# ==========================	
	$getRequests = ()->
		# admin get.	
		if $rootScope.isAdmin
			Locrequest.index().then (resp)->
				$requests = resp.data
		# reg. usr		
		else
			Locrequest.indexmy($rootScope.user.uid).then (resp)->
				$requests = resp.data

	$filterRequest = ($requests)->
		defer = $q.defer()

		for req in $requests

			if req.p2_done == 'true'
				if req.p2_result == 'true'
					$scope.request.p3.push req
				else
					$scope.request.p4.push req

			else if req.p2_done == 'false'

				if req.p1_done == 'true'
					if req.p1_result == 'true'
						$scope.request.p2.push req
					else
						$scope.request.p4.push req
				else
					$scope.request.p1.push req

			else
				console.log 'not a valid req'


		defer.resolve $scope.request
		defer.promise	
	
	$requestRender = ()->
			$rootScope.openLoading()

			$getRequests().then ($requests)->
				$filterRequest($requests).then ()->
					$rootScope.closeLoading() 

	$requestRender()


	# ==================
	$scope.changeLabel = ($ind)->
		$scope.status = $ind

]